import { Link } from "react-router-dom";
import React, { PropsWithChildren } from "react";

interface Props extends PropsWithChildren {
    selected: boolean;
    to: string;
}

export function NavigationBarLink({
    selected,
    to,
    children
}: Props): JSX.Element {
    return (
        <Link
            to={to}
            className={`transition-colors flex w-full px-[32px] py-[16px] gap-8 text-sm items-center hover:bg-secondary-blue-subtle rounded text-primary-identity-Blue ${
                selected
                    ? "bg-secondary-blue-lightest font-semibold"
                    : "font-normal"
            }`}
        >
            {children}
        </Link>
    );
}
